// 公共方法
// import publicData from "../../../store/components/publicData";
const publicData = {
  state:store.state.tradeData
}
import store from '@/store/index'
export default {

  daojishi(mistiming) {
    //也可以传截止的具体时间，改一下参数
        // var newtime = new Date() //获取当前时间
        // var storptime = new Date(storptimes) //获取截止时间
        // var mistiming = storptime.getTime() - newtime.getTime() //   获取截止时间距离现在的毫秒差
        if(mistiming>0){
        var days = Math.floor(mistiming / 1000 / 60 / 60 / 24); //获取天数
        var hours = Math.floor(mistiming / 1000 / 60 / 60 % 24); // 获取小时
        var minutes = Math.floor(mistiming / 1000 / 60 % 60); //获取分钟数
        var seconds = Math.floor(mistiming / 1000 % 60); //获取秒数

        // 判断天、时、分、秒是不是两位数，如果是直接输出，如果不是在前边加个0;
        days < 10 ? days = "0" + days : days;
        hours < 10 ? hours = "0" + hours : hours;
        minutes < 10 ? minutes = "0" + minutes : minutes;
        seconds < 10 ? seconds = "0" + seconds : seconds;

        // 第一种连接方法
        // var rels = days + "天" + hours + "时" + minutes + "分" + seconds + "秒";
        // 第二种连接方法
        var rels = `${days}天${hours}时${minutes}分${seconds}秒`}

        // 判断时间差是不是正数，就是截止时间是不是比现在的时间晚
        var mis = mistiming > 0 ? rels : "已超时"
        return mis
    },

    // 经营时间
dateTermFilters(val){
    if(val&&val.indexOf(',')>=0&&val.indexOf('-')>=0){
        let isval=val.split(',')[0]
        var nowDate = new Date(new Date(new Date().toLocaleDateString())).getTime()//当前时间0分0时0秒
        var isValDate = new Date(new Date(new Date(isval).toLocaleDateString())).getTime()//经营开始时间
        let valType=parseInt((nowDate-isValDate)/31622399000)
        if(valType<1){
            return '1年以下'
        }else{
            return valType+'年'
        }
    }else if(val&&val.indexOf('至')>=0&&val.indexOf('-')>=0){
        let isval=val.split('至')[0]
        var nowDate = new Date(new Date(new Date().toLocaleDateString())).getTime()//当前时间0分0时0秒
        var isValDate = new Date(new Date(new Date(isval).toLocaleDateString())).getTime()//经营开始时间
        let valType=parseInt((nowDate-isValDate)/31622399000)
        if(valType<1){
            return '1年以下'
        }else{
            return valType+'年'
        }
    }else{
        if(val){
            return val
        }else{
            return "--"
        }
    }
},

//会员等级
memberLevelFilters(val) {
    switch(val){
        case 'COMMON':
          return '普通会员';
        case 'SILVER':
        return '白银用户';  
        case 'GOLD':
          return '黄金用户';
        case 'PLATINUM':
          return '铂金用户';
        case 'DIAMOND':
          return '钻石用户';
    }
},



  busTypeFilters:function(val){
      if(val=='GSJY'){
          return '公司'
      }else if(val=='WD'){
          return '网店'
      }else if(val=='XMT'){
          return '新媒体'
      }else if(val=='BQ'){
          return '著作权'
      }else if(val=='SB'){
          return '商标'
      }else if(val=='WZ'){
          return '网站'
      }else if(val=='ZL'){
          return '专利'
      }
  },
  

  //服务类别
  serviceTypeFilter(val){
      if(val){
         let arr = [];
         let value = [];
         if(val.split(',')){
            arr = val.split(',');
         }else{
            arr.push(val) 
         }
         arr.forEach(item=>{
              if(item=='GSJY'){
                  value.push('公司');
              }else if(item=='WD'){
                 value.push('网店');
              }else if(item=='XMT'){
                value.push('新媒体');
              }else if(item=='BQ'){
                value.push('著作权');
              }else if(item=='SB'){
                value.push('商标');
              }else if(item=='WZ'){
                value.push('网站');
              }else if(item=='ZL'){
                value.push('专利');
              }
          })
         let serviceType = value.map(item=>item).join();
         return serviceType;
      }
  },





// 金额转换
changeMoney(num) {
  // var regexp = /(?:\.0*|(\.\d+?)0+)$/
  if(num){
  if (num > 10000) {
    num = JSON.stringify(num) / 10000
    return num + '万元'
  } else {
    //  num = (num / 100).toFixed(2)
    //  num = num.replace(regexp, '$1')
     return num + '元'
  }
}else{
    return '-'
  }
},


// 过滤订单详情页的数据
allTypeDetailFilters:function(val,name,type){
  // 日期过滤
  if(val&&typeof val!='number'&&val.indexOf(',')>=0&&val.indexOf('-')>=0){
    let isval=val.split(',')[0]
    var nowDate = new Date(new Date(new Date().toLocaleDateString())).getTime()//当前时间0分0时0秒
    var isValDate = new Date(new Date(new Date(isval).toLocaleDateString())).getTime()//经营开始时间
    let valType=parseInt((nowDate-isValDate)/31622399000)
    if(valType<1){
        return '1年以下'
    }else{
        return valType+'年'
    }
  }else if(val&&typeof val!='number'&&val.indexOf('至')>=0&&val.indexOf('-')>=0){
      let isval=val.split('至')[0]
      var nowDate = new Date(new Date(new Date().toLocaleDateString())).getTime()//当前时间0分0时0秒
      var isValDate = new Date(new Date(new Date(isval).toLocaleDateString())).getTime()//经营开始时间
      let valType=parseInt((nowDate-isValDate)/31622399000)
      if(valType<1){
          return '1年以下'
      }else{
        return valType+'年'
      }
  }else if(val&&typeof val!='number'&&val.indexOf('万')>=0){
    if(Number(val.split('万')[0])>10000){
        return Number(val.split('万')[0])/10000+'亿'
    }else{
        return val.split('万')[0]+'万'
    }
  }else{
      if(val){
        if(name=='成交量' || name=='日访问量' || name=='粉丝数量'){
          if(val&&Number(val)>=10000){
              return (Number(val)/10000).toFixed(2)+'W'
          }else{
              return val
          }
        }else if(name=='店铺年限' || name=='授权期限'){
          return val+'年'
        }else if(name=='评分'){
          return val+'分'
        }else{
          return val
        }
      }else{
          return "--"
      }
  }
},



// 数据公共过滤
tablevalueFilters:function(val){
  if(val){
    return val
  }else{
    return '-'
  }
},


//网店平台类型过滤
platTypeDataFilter(val) {
  let valNum = Number(val);
  switch (valNum) {
  case 1:
      return "京东";
  case 2:
      return "天猫";
  case 3:
      return "淘宝";
  case 4:
      return "蘑菇街";
  case 5:
      return "亚马逊";
  case 6:
      return "小红书";
  case 7:
      return "1688";
  case 8:
      return "拼多多";
  default:
      return "其他";
  }
},

  // 时间戳
  timestampToDate(value) {
    if (value) {
      var date = new Date(value); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() + "-";
      var M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      var D = date.getDate() < 10 ? "0" + date.getDate() : date.getDate()
      return Y + M + D;
    }else{
      return '-'
    }
  },
  // 时间戳
  timestampToTime(val) {
    if (val) {
      var date = new Date(val); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() + "-";
      var M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      var D =
        (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
      var h =
        (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
      var m =
        (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
        ":";
      var s =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      return Y + M + D  +  h + m + s;
    }else{
      return '-'
    }
  },

   // 时间戳
  ymdToTime(val) {
    if (val) {
      var date = new Date(val); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() + "-";
      var M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      var D =
        (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
      var h =
        (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
      var m =
        (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
        ":";
      var s =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      return Y + M + D ;
    }else{
      return '-'
    }
  },
  // 时间戳
  hmsToTime(val) {
    if (val) {
      var date = new Date(val); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() + "-";
      var M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      var D =
        (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
      var h =
        (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
      var m =
        (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
        ":";
      var s =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      return h + m + s;
    }else{
      return '-'
    }
  },

// 金额转换
changeMoney(num) {
  // var regexp = /(?:\.0*|(\.\d+?)0+)$/
  if(num){
  if (num > 10000) {
  num = JSON.stringify(num) / 10000
  return num + '万元'
  } else {
  //  num = (num / 100).toFixed(2)
  //  num = num.replace(regexp, '$1')
  return num + '元'
  }
}else{
  return '-'
  }
},
  hmsstampToTime(val) {
    if (val) {
      var date = new Date(val); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() + "-";
      var M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      var D =
        (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
      var h =
        (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
      var m =
        (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
        ":";
      var s =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      return h + m + s;
    }else{
      return '-'
    }
  },
  //图片地址
  imgFilter(val) {
    if (val) {
      var val = val.split("/");
      var valNum = val.length;
      var valid;
      for (var i = 0; i < valNum; i++) {
        valid = val[valNum - 1];
      }
      return publicData.state.showFile + valid;
    } else {
      return "/static/img/zanwu3.png";
    }
  },
  //图片回显 不带token
  coverPhotoUrlFilters:function(val){
      if(val){
          return publicData.state.showFile+val
      }
  },
  
  //认证类型
  identityFilter(val){
        switch(val){
           case '3':
             return '银行对公账号';
            default:
              return '企业认证'
        }
  },

  imgUrlFilters(val){
    if(val){
        if(val.indexOf('open/')>=0){
            return publicData.state.showFile+val.split('open/')[1]
        }else{
            return publicData.state.showFile+val
        }
    }else{
        return "/static/image/zanwu3.png";
    }
},
  //图片地址3
  filePathFilter(val) {
    if (val) {
      var val = val.split("/");
      var valNum = val.length;
      var valid;
      for (var i = 0; i < valNum; i++) {
        valid = val[valNum - 1];
      }
      return publicData.state.showFile + valid;
    } else {
      return "/static/img/zanwu.png";
    }
  },
  
  //图片路径过滤器
  filePathFilter2(val) {
    if (val) {
      var val = val.split("/");
      var valNum = val.length;
      var valid;
      for (var i = 0; i < valNum; i++) {
        valid = val[valNum - 1];
      }
      return publicData.state.showFile + valid;
    } else {
      return "/static/img/zanwu2.png";
    }
  },
  //登记状态
  regisSateTypeFilter(val) {
      let valNum = Number(val);
      switch (valNum) {
      case 0:
          return "已下证";
      case 1:
          return "登记中";
      default:
          return '-';
      }
},

shopTypeFilter(val){
  let wdDpType = publicData.state.wdDpType
  if(val){
    let _val = []
    let list = []
    if(typeof val == 'string'){
      _val = val.split(',')
    }else if(typeof val == 'object'){
      _val = val
    }
    _val.forEach(v=>{
      list.push(wdDpType.find(c=> c.value == v).label)
    })
    return list.join(',')
  }else{
    return ''
  }
},
//交易方式
transWayTypeFilter(val) {
  let valNum = Number(val);
  switch (valNum) {
  case 0:
      return "转让";
  case 1:
      return "授权";
  case 2:
      return "分账";
  default:
      return '-';
  }
},

// 企业类型
companyFilters(val){
  if(val=='0'){
      return '全部'
  }else if(val=='1'){
      return '有限责任公司'
  }else if(val=='2'){
      return '股份公司'
  }else if(val=='3'){
      return '集团公司'
  }else if(val=='4'){
      return '有限合伙企业'
  }else if(val=='5'){
      return '普通合伙企业'
  }else if(val=='6'){
      return '个人独资企业'
  }else{
    return "/"
  }
},

//出售类别
saleTypeFilter(val) {
  let valNum = Number(val);
  switch (valNum) {
  case 1:
      return "官方自营";
  case 2:
      return "第三方服务";
  default:
      return '-';
  }
},


  //商标类型
  brandFenFilters(val){
      if (val == "0") {
        return "中文";
      } else if (val == "1") {
        return "英文";
      } else if (val == "2") {
        return "中文+英文";
      } else if (val == "3") {
        return "图形";
      }else if (val == "4") {
        return "中文+图形";
      }else if (val == "5") {
        return "组合";
      }else if (val == "6") {
        return "数字";
      }else if (val == "7") {
        return "拼音";
      }else if (val == "8") {
        return "英文+图形";
      }else if (val == "9") {
        return "中文+拼音";
      }else if (val == "10") {
        return "中文+英文+图形";
      }else{
        return "/"
      }
  },

  //产品类型
  productType(val) {
    if (val == "0") {
      return "产品";
    } else if (val == "1") {
      return "套餐";
    }else{
      return "/"
    }
  },
  //公司性质
  natureFilter(val) {
      if (val == "0") {
        return "小规模";
      }  else if (val == "1") {
        return "未核税种";
      }else if (val == "2") {
        return "一般纳税人";
      } else if (val == "") {
        return "不限";
      }else{
        return "/"
      }
  },

  //专利类型
  patentTypeFilter(val) {
      if (val == "0") {
        return "发明授权";
      } else if (val == "1") {
        return "实用新型";
      } else if (val == "2") {
        return "外观设计";
      } else if (val == "3") {
        return "发明公布";
      }else{
        return "/"
      }
  },


  // 著作权过滤
  copyrightFilters(val){
    let valNum=Number(val)
    switch (valNum) {
        case 1 :
            return '小说作品'
        case 2:
            return '剧本作品';
        case 3:
            return '人文社科';
        case 4:
            return '美术作品';
        case 5:
            return '漫画作品';
        case 6:
            return '摄影作品';
        case 7:
            return '软件作品';
        case 8:
            return '图形作品';
        case 9:
            return '电影';
        case 10:
            return '电视剧';
        case 11:
            return '动画片';
        case 12:
            return '栏目';
        case 13:
            return '人才类';
        case 14:
            return '其他视频';
        case 15:
            return '音乐';
        case 16:
            return '游戏';
        case 17:
            return '其他作品';
        default:
            return "--";
    }
},


  //著作权类型和题材的两级数据过滤(传入数据类型 val = 1,2;输出类型：小说作品/古言穿越)
  themeDoubleFilter(val) {
    if(val){
    let valList = val.split(",");
    let oneClass = valList[0];
    let twoClass = valList[1];
    let returnVal = "";
    publicData.state.themeData.forEach(element => {
    if (element.bigId == oneClass) {
        returnVal = element.name;
        if (twoClass) {
        element.children.forEach(son => {
            if (son.childId == twoClass) {
            returnVal = returnVal + "/" + son.val;
            }
        });
        }
    }
    });
    return returnVal;
}else{
  return "/"
}
},

// 附带资产
incidentallyFilters:function(val){
  if(!val){
    return ''
  }
  let list = publicData.state.incidentallys
  let res=''
  val.forEach(item=>{
    let a = list.find(v=>{ return v.value == item }).name
    res += a + ",";
  })

  let s= res.substring(0,res.length  - 1)


  return s
},

  //企业类型
  typeFilters(val) {
      if (val == "1") {
        return "有限责任公司";
      } else if (val == "2") {
        return "个人独资公司";
      } else if (val == "3") {
        return "港澳台公司";
      } else if (val == "4") {
        return "集团公司";
      }else{
        return "/"
      }
  },

  //出售类别
  saleTypeFilters(val){
      if (val == "1") {
        return "官方自营";
      } else if (val == "2") {
        return "第三方服务";
      }else{
        return "/"
      }
  },

 // 专利状态
 stateFilters:function(val){
  if(val==0){
      return '授权未下证'
  }else if(val==1){
      return '已下证'
  }else{
    return "--"
  }
},



  //支付方式
  // paymentWayFilter(val){
  //     if(val=="1"){
  //     return "腾讯平台"
  //     }else if(val=="2"){
  //         return "支付宝"
  //     }else if(val=='3'){
  //         return "财付通"
  //     }else if(val=="4"){
  //         return "微信"
  //     }else if(val=='5'){
  //         return "私账 "
  //     }else if(val=="6"){
  //         return "公账"
  //     }else if(val=="7"){
  //         return "刷卡"
  //     }else if(val=="8"){
  //         return "现金"
  //     }
  // },

  paymentWayFilter(val) {
    if (val == "1") {
      return "微信";
    } else if (val == "2") {
      return "支付宝";
    } else if (val == "5") {
      return "企业支付宝";
    } else if (val == "6") {
      return "对公";
    } else if (val == "7") {
      return "联合银行(黄功成)";
    } else if (val == "8") {
      return "联合银行(孙玉芝)";
    } else if (val == "9") {
      return "淘宝";
    } else if (val == "10") {
      return "工商银行(对公银行)";
    } else if (val == "11") {
      return "企业微信";
    } else if (val == "12") {
      return "农业银行(爱华对公)";
    } else if (val == "13") {
      return "支付宝(爱华)";
    }else{
      return "/"
    }
  },

  //地址是否异常
  isExceptionFilter(val) {
    return val == "1" ? "是" : "否";
  },
  //可否领票
  takeTicketFilter(val) {
    return val === "1" ? "可以" : val === "2" ? "不能" : "/";
  },
  //使用状态
  usagesFilter(val) {
    return val === "1"
      ? "未使用"
      : val === "2"
      ? "已使用"
      : val === "3"
      ? "需警示"
      : "/";
  },
  //异常类型
  exceptionStatusFilter(val) {
    return val === "1" ? "地址异常" : val === "2" ? "其他异常" : "/";
  },
  //解除异常情况
  exceptionsFilter(val) {
    if (val == "1") {
      return "可以";
    } else if (val == "2") {
      return "不可以";
    } else if (val == "3") {
      return "可以（+2000）";
    } else if (val == "4") {
      return "可以（+3500）";
    }else{
      return "/"
    }
  },
  // 审核状态过滤  组织机构 短信设置
  mobanStatusFilter(val) {
    return val === "0"
      ? "已通过"
      : val === "1"
      ? "待审核"
      : val === "2"
      ? "已拒绝"
      : "/";
  },
  //产品供应商类型
  remarkFilter(val) {
    return val === "0" ? "自营" : val === "1" ? "供应商" : "/";
  },
  //员工列表性别
  sexFilter(val) {
    return val === "0" ? "女" : val === "1" ? "男" : "/";
  },
  //员工列表是否参与排行榜
  isPxbFilter(val) {
    return val === "0" ? "不参与" : val === "1" ? "参与" : "/";
  },
  //员工列表是否参与了折扣
  isZhekouFilter(val) {
    return val === "0" ? "不参与" : val === "1" ? "参与" : "/";
  },
  //反馈状态
  backlogStatusFilter(val) {
    return val === "1" ? "待处理" : val === "2" ? "已处理" : "/";
  },
  //反馈类型
  remarkStatusFilter(val) {
    if (val == "0") {
      return "快递单号";
    } else if (val == "1") {
      return "备注";
    } else if (val == "2") {
      return "确认结果";
    }else{
      return "/"
    }
  },
  //是否显示给客户
  isShowFilter(val) {
    return val === "0" ? "是" : val === "1" ? "否" : "/";
  },
  workStautsFilter(val) {
    if (val == "0") {
      return "已完成";
    } else if (val == "1") {
      return "服务中";
    } else if (val == "2") {
      return "审核中";
    } else if (val == "3") {
      return "审核未通过";
    } else if (val == "4") {
      return "地址审核";
    } else if (val == "5") {
      return "地址审核中";
    } else if (val == "6") {
      return "审核通过";
    } else if (val == "8") {
      return "交接单待填写";
    } else if (val == "9") {
      return "交接单已填写";
    }else{
      return "/"
    }
  },
  //记账费是否已付
  acountStausFliter(val) {
    return val === "1" ? "是" : val === "2" ? "否" : "/";
  },
  //网站栏目中  状态
  questionStatusFilter(val) {
    if (val == "0") {
      return "审核通过";
    } else if (val == "1") {
      return "待审核";
    } else if (val == "2") {
      return "审核失败";
    }else{
      return "/"
    }
  },
  //网站栏目中 状态
  enableFilter(val) {
    if (val == "0") {
      return "启用";
    } else if (val == "1") {
      return "未启用";
    }else{
      return "/"
    }
  },
  //回复人类型
  answererTypeFilter(val) {
    if (val == "0") {
      return "用户";
    } else if (val == "1") {
      return "工商会计";
    }else{
      return "/"
    }
  },

  //金额大写
  priceDaXie(n) {
    var fraction = ["角", "分"];
    var digit = ["零", "壹", "贰", "叁", "肆", "伍", "陆", "柒", "捌", "玖"];
    var unit = [
      ["元", "万", "亿"],
      ["", "拾", "佰", "仟"]
    ];
    var head = n < 0 ? "欠" : "";
    n = Math.abs(n);
    var s = "";
    for (var i = 0; i < fraction.length; i++) {
      s += (
        digit[Math.floor(n * 10 * Math.pow(10, i)) % 10] + fraction[i]
      ).replace(/零./, "");
    }
    s = s || "整";
    n = Math.floor(n);
    for (var i = 0; i < unit[0].length && n > 0; i++) {
      var p = "";
      for (var j = 0; j < unit[1].length && n > 0; j++) {
        p = digit[n % 10] + unit[1][j] + p;
        n = Math.floor(n / 10);
      }
      s = p.replace(/(零.)*零$/, "").replace(/^$/, "零") + unit[0][i] + s;
    }
    return (
      head +
      s
        .replace(/(零.)*零元/, "元")
        .replace(/(零.)+/g, "零")
        .replace(/^整$/, "零元整")
    );
  },



  // 开户情况
  isOpenFilter(val) {
    return val == "1" ? "已开基本户" : "未开基本户";
  },

  //ndd新增---2020年12月3日15:00:18--
  //著作权类型和题材的两级数据过滤(传入数据类型 val = 1,2;输出类型：小说作品/古言穿越)
  themeDoubleFilter(val) {
    if(val){
    let valList = val.split(",");
    let oneClass = valList[0];
    let twoClass = valList[1];
    let returnVal = "";
    publicData.state.themeData.forEach(element => {
      if (element.bigId == oneClass) {
        returnVal = element.name;
        if (twoClass) {
          element.children.forEach(son => {
            if (son.childId == twoClass) {
              returnVal = returnVal + "/" + son.val;
            }
          });
        }
      }
    });
    return returnVal;
  }
  },
  //出售类别
  saleTypeFilter(val) {
    let valNum = Number(val);
    switch (valNum) {
      case 1:
        return "官方自营";
      case 2:
        return "第三方服务";
      default:
        return '-';
    }
  },
  //交易方式
  transWayTypeFilter(val) {
    let valNum = Number(val);
    switch (valNum) {
      case 0:
        return "转让";
      case 1:
        return "授权";
      case 2:
        return "分账";
      default:
        return '-';
    }
  },
  //专利类型
  patentTypeFilter(val) {
    let valNum = Number(val);
    switch (valNum) {
      case 0:
        return "发明授权";
      case 1:
        return "实用新型";
      case 2:
        return "外观设计";
      case 3:
        return "发明公布";
      default:
        return '-';
    }
  },
  //登记状态
  regisSateTypeFilter(val) {
    let valNum = Number(val);
    switch (valNum) {
      case 0:
        return "已下证";
      case 1:
        return "登记中";
      default:
        return '-';
    }
  },
  //媒体类型过滤
  ptTypeFilter(val) {
        if(val=='0') return '抖音';
        if(val=='1') return '快手';
        if(val=='2') return '微博';
        if(val=='3') return '百家号';
        if(val=='4') return '微信公众号';
        if(val=='5') return '今日头条';
        if(val=='6') return '其他';
        if(val=='7') return '虎牙';
        if(val=='8') return '斗鱼';
        if(val=='9') return '哔哩哔哩';
        if(val=='10') return '小红书';
  },
  //行业类型过滤
  industryFilter(val) {
    let valNum = Number(val);
    switch (valNum) {
      case 0:
        return "不限";
      case 1:
        return "农林牧业";
      case 2:
        return "食品饮料";
      case 3:
        return "家具用品";
      case 4:
        return "教育休闲";
      case 5:
        return "医药与医疗";
      case 6:
        return "化学化工";
      case 7:
        return "电气自动化";
      case 8:
        return "新能源";
      case 9:
        return "电子信息源";
      case 10:
        return "仪器仪表";
      case 11:
        return "环保和资源";
      case 12:
        return "轻工纺织";
      case 13:
        return "包装印刷";
      case 14:
        return "建筑建材";
      case 15:
        return "新型材料";
      case 16:
        return "海洋开发";
      case 17:
        return "航空航天";
      case 18:
        return "采矿冶金";
      case 19:
        return "交通运输";
      case 20:
        return "橡胶塑料";
      case 21:
        return "机械";
      case 22:
        return "安全防护";
      case 23:
        return "其他";
      default:
        return '-';
    }
  },
  //网站类型过滤
  webTypeFilter(val) {
    let valNum = Number(val);
    switch (valNum) {
      case 1:
        return "垂直行业";
      case 2:
        return "游戏";
      case 3:
        return "软件下载";
      case 4:
        return "电影视频";
      case 5:
        return "小说";
      case 6:
        return "音乐DJ";
      case 7:
        return "地方门户";
      case 8:
        return "动漫";
      case 9:
        return "女性时尚";
      case 10:
        return "新闻娱乐";
      case 11:
        return "母婴亲子";
      case 12:
        return "教育培训";
      case 13:
        return "金融财经";
      case 14:
        return "体育直播";
      case 15:
        return "星座命理";
      case 16:
        return "美食菜谱";
      case 17:
        return "健康养生";
      default:
        return '-';
    }
  },
  //系统类型过滤
  sysTypeFilter(val) {
    let valNum = Number(val);
    switch (valNum) {
      case 1:
        return "Dede织梦";
      case 2:
        return "帝国Cms";
      case 3:
        return "蚂蚁Cms";
      case 4:
        return "Zblog";
      case 5:
        return "杰奇";
      case 6:
        return "苹果Cms";
      case 7:
        return "Discuz";
      case 8:
        return "WordPress";
      case 9:
        return "PHP";
      case 10:
        return "ASP";
      case 11:
        return ".NET";
      case 12:
        return "JAVA";
      case 13:
        return "自研程序";
      case 14:
        return "其他";
      default:
        return '-';
    }
  },
  //百度权重过滤
  weightFilter(val) {
    let valNum = Number(val);
    switch (valNum) {
      case 1:
        return "BDR0";
      case 2:
        return "BDR1";
      case 3:
        return "BDR2";
      case 4:
        return "BDR3";
      case 5:
        return "BDR4";
      case 6:
        return "BDR5";
      case 7:
        return "BDR6";
      case 8:
        return "BDR7+";
      default:
        return '-';
    }
  },
  //企业类型过滤
  companyTypeFilter(val) {
    let valNum = Number(val);
    switch (valNum) {
      case 0:
        return "全部";
      case 1:
        return "有限责任公司";
      case 2:
        return "股份公司";
      case 3:
        return "集团公司";
      case 4:
        return "有限合伙企业";
      case 5:
        return "普通合伙企业";
      case 6:
        return "个人独资企业";
      default:
        return '-';
    }
  },
  //公司性质(传入数据类型 val = 1,2 输出类型：小规模纳税人/零申报)
  cascaderDoubleFilter(val) {
    if(val){
    let valList = val.split(",");
    let oneClass = valList[0];
    let twoClass = valList[1];
    let returnVal = "";
    publicData.state.cascaderOptionsBuy.forEach(element => {
      if (element.value == oneClass) {
        returnVal = element.label;
        if (twoClass) {
          element.children.forEach(son => {
            if (son.value == twoClass) {
              returnVal = returnVal + "/" + son.label;
            }
          });
        }
      }
    });
    return returnVal;
  }
  },
  //所属行业类别的两级数据过滤(传入数据类型 val = 1,2 输出类型：贸易类/经贸发展)
  industryDoubleFilter(val) {
    if(val){
    let valList = val.split(",");
    let oneClass = valList[0];
    let twoClass = valList[1];
    let returnVal = "";
    publicData.state.industryListVal.forEach(element => {
      if (element.bigId == oneClass) {
        returnVal = element.name;
        if (twoClass) {
          element.children.forEach(son => {
            if (son.childId == twoClass) {
              returnVal = returnVal + "/" + son.val;
            }
          });
        }
      }
    });
    return returnVal;
  }
},

   
//举报类型
reportFilters(val){
   switch(val){
       case '1':
       return '虚假交易';
       case '2':
       return '滥发信息';
       case '3':
       return '出售违禁品';
       case '4':
       return '商品信息有误';
       case '5':
       return '虚假宣传';
       case '6':
       return '政治有害类';
       case '0':
       return '其他';
   }
},

// 支付方式
payTypeFilter(val){
  switch(val){
     case '3':
       return '余额'
     case '2':
       return '支付宝'
     case '1':
       return '微信'
       case '1,2':
        return '微信,支付宝'
   }
},
// 商品价格
goodsPrice:function(val,omit){
  let text = ''
  if(val){
    let num = Number(val)
    if(num >= 10000){
      // 以万为单位
      let _num = num / 10000
      let count;// 小数点后的数字 string类型
      if(String(_num).indexOf(".") != -1){
        count = _num.toString().replace(/\d+\.(\d*)/,"$1")
      }
      if(count){
        if(count.length <= 2){
          text = _num + '万'
        }else{
          text = _num.toFixed(2) + '万'
        }
      }else{
        text = _num + '万'
      }
    }else{
      // 低于一千
      let count;// 小数点后的数字 string类型
      if(String(num).indexOf(".") != -1){
        count = num.toString().replace(/\d+\.(\d*)/,"$1")
      }
      if(count){
        if(count.length == 1){
          text = num + '0元 '
        }else if(count.length == 2){
          text = num + '元'
        }else{
          text = num.toFixed(2) + '元'
        }
      }else{
        // omit 是否显示 .00
        if(omit){
          text = num + '元'
        }else{
          text = num + '.00元'
        }
      }
    }
  }else{
    text = "--"
  }
  return text
}


};



// WEBPACK FOOTER //
// ./src/assets/js/common/globalFilter.js